import React from "react";
import { Row, Col, Button, ButtonGroup } from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useGlobalState } from "../../components/globalStateProvider";
import "./css/DateRangeSelector.css";  // <-- aggiungi il CSS di stabilizzazione


const ProductionDateRangeSelector = () => {
  const { startDateProduction, endDateProduction, setDateRangeProduction } = useGlobalState();

  // --- PRESET RAPIDI ---
  const today = new Date();

  const setLastDays = (days) => {
    const from = new Date();
    from.setDate(today.getDate() - days);
    setDateRangeProduction([from, today]);
  };

  const setYear = (year) => {
    setDateRangeProduction([new Date(year, 0, 1), new Date(year, 11, 31)]);
  };

  return (
    <>
      <Row className="text-center mt-4 mb-1">
        <p>Seleziona il periodo:</p>
      </Row>

      {/* 🔹 Barra dei preset */}
      <Row className="mb-3">
        <Col className="d-flex justify-content-center">
          <ButtonGroup>
            <Button variant="outline-primary" onClick={() => setLastDays(30)}>Ultimi 30 gg</Button>
            <Button variant="outline-primary" onClick={() => setLastDays(60)}>Ultimi 60 gg</Button>
            <Button variant="outline-primary" onClick={() => setLastDays(90)}>Ultimi 90 gg</Button>
            <Button variant="outline-secondary" onClick={() => setYear(2025)}>Anno 2025</Button>
            <Button variant="outline-secondary" onClick={() => setYear(2024)}>Anno 2024</Button>
          </ButtonGroup>
        </Col>
      </Row>

      {/* 🔹 Date Range Picker */}
      <Row className="text-center mt-1 mb-4">
        <Col className="d-flex justify-content-center">
          <DatePicker
            showIcon
            selectsRange
            startDate={startDateProduction}
            endDate={endDateProduction}
            onChange={(update) => setDateRangeProduction(update)}
            isClearable
            withPortal
            dateFormat="yyyy/MM/dd"
            maxDate={new Date()}
            allowSameDay
            showWeekNumbers
            calendarStartDay={1}
            className="datepicker-stable"
            calendarClassName="datepicker-stable-calendar"
          />
        </Col>
      </Row>
    </>
  );
};

export default ProductionDateRangeSelector;
 